<template>
  <div class="other-type-wrapper" style="height: 100%">
    <div style="background-color:#fff;height: 100%">
      <el-tabs v-model="activeStatus" @tab-click="handleClick" style="height: 100%">
        <el-tab-pane label="文本" name="1">
          <el-scrollbar :style="{'height': otherTextArr.length < 50 ? 'calc(100% - 35px)':'100%'}">
            <div style="padding-right:20px;">
              <div class="other-text text-hover" v-for="(item,index) in otherTextArr" :key="index">
                <p draggable class="other-text-title" @dragstart="(e)=>{dragstart(e,item)}"
                  :title="item.displayContent">
                  {{item.displayContent}}
                </p>
                <span class="text-del" @click="handleDelText(item,index)">删除</span>
              </div>
              <!-- 添加文本 -->
              <div v-show="addTextStatus" class="add-other-text">
                <h2>添加文本</h2>
                <el-input type="textarea" :rows="5" placeholder="请输入文本内容" v-model="textData" maxlength="100"
                  show-word-limit>
                </el-input>
                <div class="add-other-bottom">
                  <el-button size="small" @click="handleCancelText">取消</el-button>
                  <el-button type="primary" size="small" @click="saveTextForm">保存</el-button>
                </div>
              </div>
            </div>
          </el-scrollbar>
          <el-button v-if="otherTextArr.length < 50" size="small" class="add-btn" type="primary"
                @click="handleAddText"> + 添加文本</el-button>
        </el-tab-pane>
        <el-tab-pane label="宣教" name="2">
          <el-scrollbar style="height: 100%">
            <div style="padding-right:20px;">
              <div class="other-text" v-for="(item,index) in otherArticleArr" :key="index">
                <div class="other-article-title">
                  <span draggable :title="item.displayContent"
                    @dragstart="(e)=>{dragstart(e,item)}">{{item.displayContent}}</span>
                  <span @click="handleDelArticle(item,index)">删除</span>
                </div>
              </div>
              <el-button v-if="otherArticleArr.length < 10" size="small" class="add-btn" type="primary"
                @click="handleAddArticle"> + 添加宣教</el-button>
            </div>
          </el-scrollbar>
        </el-tab-pane>
        <el-tab-pane label="问卷" name="3">
          <el-scrollbar style="height: 100%">
            <div style="padding-right:20px;">
              <div class="other-text" v-for="(item,index) in otherQuestionArr" :key="index">
                <div class="other-article-title">
                  <span draggable :title="item.displayContent"
                    @dragstart="(e)=>{dragstart(e,item)}">{{item.displayContent}}</span>
                  <span @click="handleDelQuestion(item,index)">删除</span>
                </div>
              </div>
              <el-button v-if="otherQuestionArr.length < 10" size="small" class="add-btn" type="primary"
                @click="handleAddQuestion"> + 添加问卷</el-button>
            </div>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 宣教弹框 -->
    <healthEducationContent v-if="showHealthy" :notDisplayArticleArr="notDisplayArticleArr"
      :showHealthy.sync="showHealthy" @receiveArticle="receiveArticle" :showCompanyBtn="true" :hospitalId="hospitalId" />
    <!-- 添加问卷 -->
    <addQuestionDialog v-if="showAddQuestion" :notDisplayQuestionList="notDisplayQuestionList" :showDiffQS="true"
      :showAddQuestion.sync="showAddQuestion" @receiveQuestion="receiveQuestion" :showCompanyBtn="true" :hospitalId="hospitalId" />
  </div>
</template>

<script>
import {
  queryInputTemplate,
  addInputTemplate,
  deleteInputTemplate
} from "@/api/otherType";
import addQuestionDialog from "@/views/ToolMaintenance/component/addQuestionDialog";
import healthEducationContent from "@/views/ToolMaintenance/component/healthEducationContent";
import local from "@/utils/local.js";

export default {
  components: {
    addQuestionDialog,
    healthEducationContent
  },
  data() {
    return {
      showAddQuestion: false,
      showHealthy: false,
      activeStatus: "1",
      textData: "",
      addTextStatus: false,
      otherTextArr: [],
      otherArticleArr: [],
      otherQuestionArr: [],
      notDisplayArticleArr: [],
      notDisplayQuestionList: [],
      decisionTreeObj: JSON.parse(localStorage.getItem('decisionTreeObj')),
      hospitalId: local.get('patientSchemeHospitalId')
    };
  },
  created() {
    this.getInitData();
    this.hospitalId = local.get('patientSchemeHospitalId')
  },
  methods: {
    async getInitData() {
      // queryInputTemplate
      let res = await queryInputTemplate({
        decisionTreeId: this.decisionTreeObj.decisionTreeId // 逻辑树的节点ID
      });
      if (res.code === 0) {
        this.otherTextArr = [];
        this.otherArticleArr = [];
        this.otherQuestionArr = [];
        // 文本
        if (res.data.length && res.data[0].dataList) {
          res.data[0].dataList.map(item => {
            this.otherTextArr.push({
              id: item.id,
              nodeType: 2, //1,"输入",2,"输出",3,"条件",4,"通知",
              outputType: 1, //1,"文本",2,"问卷",3,"宣教",4.编链
              outputContent: JSON.stringify(item), //输出实际值，根据类型传不同值，如宣教，问卷，文本，编链的详情信息，存json
              displayContent: item.content, //输出内容显示值
              render: 1
            });
          });
        }
        // 问卷
        if (res.data.length && res.data[1].dataList) {
          res.data[1].dataList.map(item => {
            this.otherQuestionArr.push({
              id: item.id,
              nodeType: 2, //1,"输入",2,"输出",3,"条件",4,"通知",
              outputType: 2, //1,"文本",2,"问卷",3,"宣教",4.编链
              outputContent: JSON.stringify(item), //输出实际值，根据类型传不同值，如宣教，问卷，文本，编链的详情信息，存json
              displayContent: item.content, //输出内容显示值
              render: 1,
              refId: item.refId
            });
          });
        }
        // 宣教
        if (res.data.length && res.data[2].dataList) {
          res.data[2].dataList.map(item => {
            this.otherArticleArr.push({
              id: item.id,
              nodeType: 2, //1,"输入",2,"输出",3,"条件",4,"通知",
              outputType: 3, //1,"文本",2,"问卷",3,"宣教",4.编链
              outputContent: JSON.stringify(item), //输出实际值，根据类型传不同值，如宣教，问卷，文本，编链的详情信息，存json
              displayContent: item.content, //输出内容显示值
              render: 1,
              refId: item.refId
            });
          });
        }
      }
    },
    handleClick() {},
    handleAddText() {
      this.addTextStatus = true;
    },
    handleCancelText() {
      this.addTextStatus = false;
      this.textData = "";
    },
    async saveTextForm() {
      if (!this.textData) {
        this.$message.error("请输入文本内容");
        return;
      }
      let res = await addInputTemplate({
        content: this.textData,
        decisionTreeId: this.decisionTreeObj.decisionTreeId, // 逻辑树的节点ID,保存后生成的一条表格数据的id
        outputType: 1
      });
      if (res.code === 0) {
        await this.getInitData();
      }
      this.addTextStatus = false;
      this.textData = "";
    },
    handleAddArticle() {
      this.notDisplayArticleArr = this.otherArticleArr.map(v => v.refId);
      this.showHealthy = true;
    },
    handleAddQuestion() {
      this.notDisplayQuestionList = this.otherQuestionArr.map(v => v.refId);
      this.showAddQuestion = true;
    },
    handleCloseArticle() {
      this.showHealthy = false;
    },
    // 接收宣教
    async receiveArticle(data) {
      let res = await addInputTemplate({
        content: data.title,
        decisionTreeId: this.decisionTreeObj.decisionTreeId,
        outputType: 3,
        refId: data.id
      });
      if (res.code === 0) {
        await this.getInitData();
      }
    },
    // 接收添加的问卷
    async receiveQuestion(data) {
      let res = await addInputTemplate({
        content: data.title,
        decisionTreeId: this.decisionTreeObj.decisionTreeId,
        outputType: 2,
        refId: data.id
      });
      if (res.code === 0) {
        await this.getInitData();
      }
    },
    dragstart(e, user) {
      e.dataTransfer.setData("user", JSON.stringify(user));
      // e.dataTransfer.setDragImage(this.$refs[user.ref], 0, 0);
    },
    // 删除
    async handleDelText(item, index) {
      let res = await deleteInputTemplate({
        id: item.id
      });
      if (res.code === 0) {
        this.otherTextArr.splice(index, 1);
      }
    },
    async handleDelArticle(item, index) {
      let res = await deleteInputTemplate({
        id: item.id
      });
      if (res.code === 0) {
        this.otherArticleArr.splice(index, 1);
      }
    },
    async handleDelQuestion(item, index) {
      let res = await deleteInputTemplate({
        id: item.id
      });
      if (res.code === 0) {
        this.otherQuestionArr.splice(index, 1);
      }
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-tabs__nav-wrap::after {
  background-color: #ffffff;
}
/deep/.el-tabs__item {
  padding: 0 30px;
  color: #333333;
}
/deep/.el-tabs__active-bar {
  width: 28px !important;
}
/deep/.el-tab-pane {
  height: 100%;
}
.add-btn {
  background-color: #fcfcfc;
  border: 1px dashed #d9d9d9;
  color: #333333;
  width: 247px;
  height: 35px;
  width: 100%;
}
.add-btn:hover {
  border: 1px dashed #1a7bfc;
  color: #1a7bfc;
  background: #fcfcfc;
}
.text-hover:hover {
  background: #F2F7FE;
}
.other-text {
  // margin-bottom: 20px;
  font-size: 12px;
  color: #333333;
  cursor: move;
  .other-text-title {
    line-height: 17px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3; //（行数）
    -webkit-box-orient: vertical;
    margin-bottom: 12px;
    word-break: break-all;
    word-wrap: break-word;
  }
  .text-del {
    display: block;
    text-align: right;
    color: #1a7bfc;
    cursor: pointer;
  }
  .other-article-title {
    display: flex;
    justify-content: space-between;
    cursor: move;
    padding: 10px 0;
    span {
      display: block;
    }
    span:nth-child(1) {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 190px;
    }
    span:nth-child(2) {
      color: #1a7bfc;
      cursor: pointer;
      width: 30px;
      text-align: right;
    }
  }
  .other-article-title:hover {
    background-color: #F2F7FE;
  }
}
.add-other-text {
  width: 423px;
  height: 244px;
  background: #f2f7fe;
  padding: 20px;
  position: fixed;
  top: 122px;
  right: 261px;
  z-index: 33;
  h2 {
    margin-bottom: 20px;
    font-size: 14px;
    font-weight: 600;
    color: #333333;
    text-align: center;
  }
  /deep/.el-textarea__inner {
    resize: none;
    font-family: "Microsoft YaHei" !important;
  }
  .add-other-bottom {
    margin-top: 20px;
    text-align: center;
    .el-button {
      width: 110px;
    }
  }
}
</style>
